<div class="backgroundColor shark darken-4">
  <section class="position-relative top-119 backgroundColor shark darken-4">
    <div class="container pt-32 pb-5">
      <div class="row">
        <div class="col-12 col-xs-12 col-sm-12 col-md-10 col-lg-6 col-xl-6 mx-auto card-color card-border">
          <div class="row col-12 text-center my-5">
            <div class="row mx-auto">
              <fa-icon [icon]="faUserCircle" class="fad fa-user-circle fa-10x textColor mine-shaft base filter"></fa-icon>
            </div>
          </div>
          <div class="row col-12 my-1">
            <div class="form-group col-12 mx-auto">
              <label class="textColor harvest-gold base">E-mail</label>&nbsp;
              <input class="form-control" type="text" [(ngModel)]="model.email">
            </div>
          </div>
          <div class="row col-12 my-1">
            <div class="form-group col-12 mx-auto">
              <label class="textColor harvest-gold base">Password</label>&nbsp;
              <input class="form-control" type="password" [(ngModel)]="model.password">
            </div>
          </div>
          <!--<div class="row col-12 my-1 mb-3">
            <div class="container">
              <div class="wrapper">
                <div class="switch_box box_1">
                  <input type="checkbox" class="switch_1">
                  <label class="mt-2 ml-1 textColor harvest-gold base">Manter-se Logado</label>
                </div>
              </div>
            </div>
          </div>-->
          <div class="row col-12 my-1 mb-3 mt-4">
            <button class="btn btn-grad px-8 ml-3 mb-3 mr-5" (click)="login()">Login</button>
            <a href="/emailRecovery" class="ln-2-5">Recuperar password</a>
          </div>
        </div>
      </div>
    </div>
  </section>

</div>